const project = {
	name: 'fe-simuladorpublicopyme',
	version: '3.9.0',
};

export const environment = {
	production: false,
	header: {
		'X-IBM-Client-Id': 'd47111e8-dc9a-4dbc-83af-9f8274c9f90a',
		'Application-Id': `${project.name}-${project.version}`,
		'Reference-Service': project.name,
		'Content-Type': 'application/json',
		'Origin-addr': '11111',
		Channel: '132',
	},
};

export const SITE_RECAPTCHA_KEY = '6LfCEFoeAAAAAOIl7BrkWn5MnQ70lf6NNDRRdkyu';

const hostWeb = 'https://crt-swc.bci.cl/pyme';
export const fe_products = {
	simuladorFogape: `${hostWeb}/fe-simuladorpublicofogape-pyme-re-v1-3`,
	simuladorCompraCartera: `${hostWeb}/fe-simuladorpublicocompracartera-pyme-re-v1-1`,
};

export const vambeIA = {
	baseUrl: 'https://api.vambe.ai/api/redirect/website/to-whatsapp',
	clientId: '73122fd6-f03b-4de6-b854-b3891d6824e9',
	phoneNumber: '56986275049',
};

const apiUrl = 'https://crt-apilocal.bci.cl';
export const apis = {
	simuladorPublicoPymeExp: `${apiUrl}/operaciones-y-ejecucion/creditos-y-depositos/ms-simuladorpublicopyme-exp/v2.1`,
	bffNormativoConsentimientos: `${apiUrl}/bff-normativo-consentimientos/v1.0`,
};
